import React from "react";
import "./footer.css";
import { Link } from "react-router-dom";
import {
  applestore,
  f,
  ig,
  inimage,
  nitrologowhite,
  playstore,
  x,
} from "../../utilities/images";

function Footer() {
  return (
    <div className='footer'>
      <div className='footer-container'>
        <div className='footer-items'>
          <img src={nitrologowhite} alt='9troRide Logo' />
          <div className='footer-item'>
            <a href='https://x.com' target="_blank" rel="noopener noreferrer">
              <img src={x} alt='X (Twitter)' />
            </a>
            <a href='https://instagram.com' target="_blank" rel="noopener noreferrer">
              <img src={ig} alt='Instagram' />
            </a>
            <a href='https://facebook.com' target="_blank" rel="noopener noreferrer">
              <img src={f} alt='Facebook' />
            </a>
            <a href='https://linkedin.com' target="_blank" rel="noopener noreferrer">
              <img src={inimage} alt='LinkedIn' />
            </a>
          </div>
        </div>{" "}
        <div className='footer-items'>
          <div className='footer-item'>
            <p className='footer-itemheader'>9TRO</p>
          </div>
          <div className='footer-item-link'>
            <Link to='/rides'>Rides</Link>
            <Link to='/9troeat'>Food</Link>
            <Link to='/package-delivery'>Deliveries</Link>
          </div>
        </div>
        <div className='footer-items'>
          <div className='footer-item'>
            <p className='footer-itemheader'>Earn with 9troride</p>
          </div>
          <div className='footer-item-link'>
            <Link to='/earn?tab=rides'>City rides</Link>
            <Link to='/earn?tab=courier'>Courier delivery</Link>
            <Link to='/earn?tab=freight'>Freight delivery</Link>
            <Link to='/earn?tab=business'>Delivery for business</Link>
          </div>
        </div>
        <div className='footer-items'>
          <div className='footer-item'>
            <p className='footer-itemheader'>PARTNER</p>
          </div>
          <div className='footer-item-link'>
            <Link to='/apply?role=driver'>Apply as a driver</Link>
            <Link to='/apply?role=courier'>Apply as a courier</Link>
          </div>
        </div>
        <div className='footer-items'>
          <div className='footer-item'>
            <p className='footer-itemheader'>COMPANY</p>
          </div>
          <div className='footer-item-link'>
            <Link to='/about'>About us</Link>
            <Link to='/careers'>Careers</Link>
            <Link to='/blog'>Blog</Link>
            <Link to='/help'>Help center</Link>
          </div>
        </div>
      </div>
      <div className='footer-container'>
        <p className='footer-link2'>© 9troRide 2024</p>
        <div className='footer-item-link2'>
          <Link to='/privacy'>Privacy</Link>
          <Link to='/terms'>Terms</Link>
        </div>
        <div className='navbar-downloadspace4'>
          <a href='/' className='downloadlink4'>
            <img src={applestore} alt='Apple store' />
            <span>Apple store</span>
          </a>
          <a href='/' className='downloadlink4'>
            <img src={playstore} alt='Play store' />
            <span>Play store</span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Footer;
